import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Careers intake. No positions are open, so this page does not collect applications.
 */
const PositionApplication: React.FC = () => (
  <div className="bg-secondary-950">
    <section className="page-shell page-section-major">
      <div className="page-inner">
        <header className="mb-6">
          <p className="text-xs font-medium tracking-[0.24em] uppercase mb-3 text-secondary-500">Careers</p>
          <h1 className="text-3xl sm:text-5xl font-bold tracking-tight mb-2">
            <span className="cw">Positions</span>
          </h1>
        </header>
        <div className="rounded-2xl border border-secondary-700/60 bg-secondary-900 p-6 sm:p-8">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-3">No positions are currently available</h2>
          <p className="text-secondary-300 leading-relaxed">
            FairCorp is not accepting applications.
          </p>
          <p className="mt-6 text-sm">
            <Link
              to="/about"
              className="font-semibold text-primary-300 hover:text-primary-200 underline underline-offset-4 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
            >
              About FairCorp
            </Link>
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default PositionApplication;
